<nav class="bar portal-nav">
    <picture [routerLink]="dashboard">
        <img src="assets/media/logos/logodef.svg" alt="Defontana" loading="lazy" />
    </picture>
    <div class="end">
        <div class="companie" id="companie" [class.single-company]="appState.OneCompany"
            [attr.role]="appState.OneCompany ? null : 'button'" [attr.tabindex]="appState.OneCompany ? null : 0"
            [attr.aria-label]="appState.OneCompany ? null : 'Cambiar empresa'"
            (keydown.enter)="openCompaniesModal()" (keydown.space)="$event.preventDefault(); openCompaniesModal()"
            (click)="openCompaniesModal()">

            <figure>
                <mat-icon class="portal-avatar" aria-hidden="true">person_outline</mat-icon>
            </figure>

            <div class="data" [matTooltip]="CompanyName">
                <span>{{CompanyName}}</span>
            </div>

            @if (!appState.OneCompany) {
            <mat-icon aria-hidden="true">arrow_drop_down</mat-icon>
            }
        </div>


        <div class="user" mat-button [matMenuTriggerFor]="menu" role="button" tabindex="0" aria-label="Menú de usuario">
            <figure>
                <mat-icon class="portal-avatar" aria-hidden="true">person_outline</mat-icon>
            </figure>
            <div class="data" [matTooltip]="Email.length > 35 && Email || '' ">
                <span>{{(userCompany$ | async)?.name || Email}}</span>
            </div>
            <mat-icon>arrow_drop_down</mat-icon>
        </div>
        <div class="menu--mobile">
            <input type="checkbox" name="checkbox" id="checkbox_id">
            <label for="checkbox_id"></label>
            <ul class="nav-links">
                <ng-container *ngIf="(userCompany$ | async); else _">
                    <li *ngFor="let item of _menu" class="nav-item">
                        <a href="javascript:void(0)" class="nav-link link" (click)="item.on()"
                            *ngIf="!item.hiden">{{item.title}}</a>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
    <mat-menu #menu="matMenu">
        <ng-container *ngIf="(userCompany$ | async); else _">
            <ng-container *ngFor="let item of _menu">
                <button (click)="item.on()" mat-menu-item *ngIf="!item.hiden">{{item.title}}</button>
            </ng-container>
        </ng-container>
        <ng-template #_>
            <button mat-menu-item *ngFor="let item of [0,1,2]">
                <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                    'width': '170px',
                    'margin': '0',
                    'border-radius': '0px',
                    'height': '10px',
                    'background-color': 'rgba(184, 184, 184, 0.2)'
                    }">
                </ngx-skeleton-loader>
            </button>
        </ng-template>

    </mat-menu>
</nav>
@if (appState.ExpirationBanner) {
<app-contenedor-banner [contador]="appState.ExpirationBanner" (pagarEnLinea)="onPagarEnLinea()">
</app-contenedor-banner>
}
@switch (appState.estadoOnboarding) {
@case (1) {
<app-contenedor-banner [contador]="false" [ocultaCierre]="true" [forzarBloqueoPantalla]="true" colorBanner="ROJO">
    <span class="banner_mensaje">
        <ng-container
            *ngIf="(obtenerInformacionOnboarding$ | async) as obtenerInformacionOnboarding; else contenedor_mensaje_cargando">
            @if(obtenerInformacionOnboarding.success){
            Para habilitar el acceso a los productos, es necesario completar el proceso de onboarding y la firma de
            contrato. Puedes iniciar este proceso desde
            <a [href]="obtenerInformacionOnboarding.urlAccess" target="_self">aquí</a>
            }
            @else{
            {{obtenerInformacionOnboarding.message}}
            }
        </ng-container>
        <ng-template #contenedor_mensaje_cargando>
            <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                        'width': '550px',
                        'margin': '0',
                        'border-radius': '0px',
                        'height': '10px',
                        'background-color': 'rgba(184, 184, 184, 0.2)'
                        }">
            </ngx-skeleton-loader>
        </ng-template>
    </span>
</app-contenedor-banner>
}
@case (2) {
<app-contenedor-banner [contador]="false" [ocultaCierre]="true" colorBanner="AMARILLO">
    <span class="banner_mensaje">
        <ng-container
            *ngIf="(obtenerInformacionOnboarding$ | async) as obtenerInformacionOnboarding; else contenedor_mensaje_cargando_pendiente">
            @if(obtenerInformacionOnboarding.success){
            Tienes un contrato pendiente de firma. Para revisarlo y completar el proceso,
            <a [href]="obtenerInformacionOnboarding.urlAccess" target="_self">Ingresa aquí</a>.
            }
            @else{
            {{obtenerInformacionOnboarding.message}}
            }
        </ng-container>
        <ng-template #contenedor_mensaje_cargando_pendiente>
            <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                        'width': '550px',
                        'margin': '0',
                        'border-radius': '0px',
                        'height': '10px',
                        'background-color': 'rgba(184, 184, 184, 0.2)'
                        }">
            </ngx-skeleton-loader>
        </ng-template>
    </span>
</app-contenedor-banner>
}
}

@if (appState.usuarioBloqueado) {
<app-contenedor-banner [contador]="false" colorBanner="ROJO"
    mensaje="Tu cuenta se encuentra bloqueada. Por favor, contacta a tu administrador para solicitar el desbloqueo.">
</app-contenedor-banner>
}

<main [class.home-main]="hiden" [class.account-main]="isUserInfo" [class.companies-main]="isCompanies" [class.security-main]="isTwoFactor" [class.password-main]="isPasswordChange" [class.settings-main]="isSettings">
    <ng-container *ngIf="!hiden && !isUserInfo && !isCompanies && !isTwoFactor && !isPasswordChange && !isSettings">
        <div class="container__header">
            <div class="arrow">
                <a [routerLink]="'/'+dashboard">
                    <span class="material-icons">arrow_back</span>
                </a>
            </div>
            <div class="content__title">
                <label for="title">{{breadcrumbs[breadcrumbs.length - 1]}}</label>
                <a [routerLink]="'/'+dashboard" style="text-decoration: none;">
                    <label for="subTitle" [innerHtml]="renderBreadcrumb"></label>
                </a>
            </div>
        </div>
    </ng-container>
    <router-outlet></router-outlet>
</main>
